(function () {
  'use strict';

  var root = document.querySelector('[data-hf-pictune-body]');
  if (!root) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* —— Reveal on scroll —— */
  var reveals = root.querySelectorAll('.hf-pt-reveal, .hf-pt-distance__path, .hf-pt-distance__plane');
  if (reveals.length) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) {
        el.classList.add('is-in');
      });
    } else {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
      );
      reveals.forEach(function (el) {
        io.observe(el);
      });
    }
  }

  /* —— Reach carousel —— */
  var carousel = root.querySelector('[data-pt-carousel]');
  if (carousel) {
    var track = carousel.querySelector('[data-pt-track]');
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-pt-dot]'));
    var prev = carousel.querySelector('[data-pt-prev]');
    var next = carousel.querySelector('[data-pt-next]');
    var count = dots.length || 2;
    var index = 0;
    var timer = null;

    function go(i) {
      index = ((i % count) + count) % count;
      if (track) track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (d, di) {
        d.classList.toggle('is-active', di === index);
      });
    }

    function start() {
      if (reduceMotion) return;
      stop();
      timer = window.setInterval(function () {
        go(index + 1);
      }, 4000);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
    if (next) next.addEventListener('click', function () { go(index + 1); start(); });
    dots.forEach(function (d, di) {
      d.addEventListener('click', function () { go(di); start(); });
    });

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    go(0);
    start();
  }

  /* —— Life stack cards —— */
  var stack = root.querySelector('[data-pt-stack]');
  if (stack) {
    var cards = Array.prototype.slice.call(stack.querySelectorAll('[data-pt-stack-card]'));
    var stackIndex = 0;
    var stackTimer = null;
    var slots = [
      { left: '0%', top: '120px', scale: 1, opacity: 1, z: 30 },
      { left: '22%', top: '60px', scale: 0.94, opacity: 0.85, z: 20 },
      { left: '44%', top: '0px', scale: 0.88, opacity: 0.7, z: 10 }
    ];

    function paintStack() {
      cards.forEach(function (card, i) {
        var offset = (i - stackIndex + cards.length) % cards.length;
        var s = slots[offset] || slots[0];
        card.style.left = s.left;
        card.style.top = s.top;
        card.style.transform = 'scale(' + s.scale + ')';
        card.style.opacity = String(s.opacity);
        card.style.zIndex = String(s.z);
      });
    }

    function startStack() {
      if (reduceMotion) return;
      stopStack();
      stackTimer = window.setInterval(function () {
        stackIndex = (stackIndex + 1) % cards.length;
        paintStack();
      }, 3000);
    }

    function stopStack() {
      if (stackTimer) {
        window.clearInterval(stackTimer);
        stackTimer = null;
      }
    }

    cards.forEach(function (card, i) {
      card.addEventListener('click', function () {
        stackIndex = i;
        paintStack();
        startStack();
      });
    });

    paintStack();
    startStack();
  }

  /* —— UWB 3D carousel —— */
  var uwb = root.querySelector('[data-pt-uwb]');
  if (uwb) {
    var uwbCards = Array.prototype.slice.call(uwb.querySelectorAll('[data-pt-uwb-card]'));
    var active = 2;
    var hovered = false;
    var uwbTimer = null;
    var n = uwbCards.length;

    function paintUwb() {
      uwbCards.forEach(function (card, index) {
        var diff = (index - active) % n;
        if (diff < -2) diff += n;
        if (diff > 2) diff -= n;
        var isCenter = diff === 0;
        var z = 10 - Math.abs(diff);
        var translateX = diff * 65;
        var scale = isCenter ? 1 : 1 - Math.abs(diff) * 0.15;
        var rotateY = diff * -25;
        card.style.zIndex = String(z);
        card.style.transform =
          'translate(-50%, -50%) translateX(' + translateX + '%) scale(' + scale + ') rotateY(' + rotateY + 'deg)';
        card.classList.toggle('is-center', isCenter);
      });
    }

    function startUwb() {
      if (reduceMotion) return;
      stopUwb();
      uwbTimer = window.setInterval(function () {
        if (hovered) return;
        active = (active + 1) % n;
        paintUwb();
      }, 2500);
    }

    function stopUwb() {
      if (uwbTimer) {
        window.clearInterval(uwbTimer);
        uwbTimer = null;
      }
    }

    uwbCards.forEach(function (card, i) {
      card.addEventListener('click', function () {
        active = i;
        paintUwb();
      });
    });

    uwb.addEventListener('mouseenter', function () { hovered = true; });
    uwb.addEventListener('mouseleave', function () { hovered = false; });

    paintUwb();
    startUwb();
  }
})();
